import { Component, ReactNode } from 'react';
import { logger } from '@/services/logger.service';
type Props = {
    children: ReactNode;
    fallback: ReactNode;
};

type State = {
    hasError: boolean;
};

class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        // Keep diagnostic logs for production troubleshooting.
        logger.error('Unhandled app error:', { error, errorInfo });
    }

    render() {
        return this.props[this.state.hasError ? 'fallback' : 'children'];
    }
}

export default ErrorBoundary;
